module.exports = __webpack_public_path__ + "img/1x.27ac6b0.jpg";